export default __webpack_public_path__ + "static/media/up.470259a3.svg";